import React, { useCallback } from "react"
import * as AppConstants from "../../../utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function BodyTableCPB(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE

    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_NUMERO_POSIZIONI_CPB}{" "}
                </th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.numPosizioniCpb
                            : elemNonDisponibile}
                    </td>
                )}

                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.numPosizioniCpb
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.numPosizioniCpb
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_REDDITO_CPB} 1° anno (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.redditoCpbA1 !== undefined
                            ? props.campo1.redditoCpbA1
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.redditoCpbA1 !== undefined
                            ? props.campo2.redditoCpbA1
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                <td>
                    {props.campo3?.redditoCpbA1 !== undefined
                        ? props.campo3.redditoCpbA1
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_REDDITO_CPB} 2° anno (media)</th>
                {props.isCampo1 && (
                    <td>
                        {props.campo1?.redditoCpbA2 !== undefined
                            ? props.campo1.redditoCpbA2
                            : elemNonDisponibile}
                    </td>
                )}
                {props.isCampo2 && (
                    <td>
                        {" "}
                        {props.campo2?.redditoCpbA2 !== undefined
                            ? props.campo2.redditoCpbA2
                            : elemNonDisponibile}{" "}
                    </td>
                )}
                <td>
                    {props.campo3?.redditoCpbA2 !== undefined
                        ? props.campo3.redditoCpbA2
                        : elemNonDisponibile}
                </td>
            </tr>

            {props.campo1?.valProdCpbA1 !== 0 &&
                props.campo2?.valProdCpbA1 !== 0 &&
                props.campo3?.valProdCpbA1 !== 0 && (
                    <tr className="tableStatIsa">
                        <th>{AppConstants.DATI_VAL_PROD_CPB} 1° anno (media)</th>
                        {props.isCampo1 && (
                            <td>
                                {props.campo1?.valProdCpbA1 !== undefined
                                    ? props.campo1.valProdCpbA1
                                    : elemNonDisponibile}
                            </td>
                        )}
                        {props.isCampo2 && (
                            <td>
                                {" "}
                                {props.campo2?.valProdCpbA1 !== undefined
                                    ? props.campo2.valProdCpbA1
                                    : elemNonDisponibile}{" "}
                            </td>
                        )}
                        <td>
                            {" "}
                            {props.campo3?.valProdCpbA1 !== undefined
                                ? props.campo3.valProdCpbA1
                                : elemNonDisponibile}{" "}
                        </td>
                    </tr>
                )}

            {props.campo1?.valProdCpbA2 !== 0 &&
                props.campo2?.valProdCpbA2 !== 0 &&
                props.campo3?.valProdCpbA2 !== 0 && (
                    <tr className="tableStatIsa">
                        <th>{AppConstants.DATI_VAL_PROD_CPB} 2° anno (media)</th>
                        {props.isCampo1 && (
                            <td>
                                {props.campo1?.valProdCpbA2 !== undefined
                                    ? props.campo1.valProdCpbA2
                                    : elemNonDisponibile}
                            </td>
                        )}
                        {props.isCampo2 && (
                            <td>
                                {" "}
                                {props.campo2?.valProdCpbA2 !== undefined
                                    ? props.campo2.valProdCpbA2
                                    : elemNonDisponibile}{" "}
                            </td>
                        )}
                        <td>
                            {" "}
                            {props.campo3?.valProdCpbA2 !== undefined
                                ? props.campo3.valProdCpbA2
                                : elemNonDisponibile}{" "}
                        </td>
                    </tr>
                )}
        </React.Fragment>
    )
}
export default BodyTableCPB
